// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('customerinvoice.customerinvoicesearch', {
        url: '/search',
        templateUrl: 'main/customerinvoice/customerinvoicesearch/customerinvoicesearch.tpl.html',
        controller: 'CustomerInvoiceSearchController as vm',
        resolve: {
            customerInvoice: function () {
                return {};
            }
        },
        params: {
            searchTerm: ''
        }
    });
    $stateProvider.state('customerinvoice.customerinvoice', {
        url: '/{invoiceId}',
        templateUrl: 'main/customerinvoice/customerinvoicesearch/customerinvoicesearch.tpl.html',
        controller: 'CustomerInvoiceSearchController as vm',
        resolve: {
            customerInvoice: customerInvoiceResolver
        },
        params: {
            searchTerm: ''
        }
    });
}

// @ngInject
function customerInvoiceResolver($stateParams, CustomerInvoiceApiService) {
    return CustomerInvoiceApiService.getById($stateParams.invoiceId);
}

// @ngInject
function CustomerInvoiceSearchController($rootScope, $state, $stateParams, $window, $scope, $translate, customerInvoice,
                                            CustomerInvoiceApiService, loadSpinnerService, ResourcesService) {
    var vm = this;

    //Properties
    vm.selectedInvoice = customerInvoice;
    vm.canAccess = $rootScope.canAccess;
    vm.showSearchFields = true;

    //Public methods
    vm.transitionToState = transitionToState;
    vm.toggleSearchFields = toggleSearchFields;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getTypeTranslation = getTypeTranslation;
    vm.goToUnboundInvoiceRows = goToUnboundInvoiceRows;

    activate();

    function activate() {
        vm.showSearchFields = true;
        if (vm.selectedInvoice && vm.selectedInvoice.id) {
            vm.showSearchFields = false;
        }
    }

    function transitionToState(invoiceId) {
        $state.go('customerinvoice.customerinvoice', { invoiceId: invoiceId });
    }

    function goToUnboundInvoiceRows() {
        $state.go('customerinvoice.customerinvoicerowsearch');
    }

    function toggleSearchFields() {
        vm.showSearchFields = !vm.showSearchFields;
    }

    function getStatusTranslation(text) {
        return $translate.instant('customerinvoice.status' + text);
    }

    function getTypeTranslation(text) {
        return $translate.instant('customerinvoice.type' + text);
    }
}

angular
    .module('customerinvoice.customerinvoicesearch', [])
    .config(stateConfig)
    .controller('CustomerInvoiceSearchController', CustomerInvoiceSearchController);
